/**
 * Frame definitions for the New Dashboard prototype.
 *
 * Two Figma frames: the populated home ("main") and the empty first-time UX
 * ("first-time"). Additional sections (agent picker overlay, etc.) are added
 * in later tasks.
 */

export type FrameId = 'main' | 'first-time'

export interface FrameDef {
  id: FrameId
  title: string
  subtitle: string
}

export const FRAMES: Record<FrameId, FrameDef> = {
  main: {
    id: 'main',
    title: 'Main dashboard',
    subtitle: 'Populated home — agents, projects, featured campaign, insights',
  },
  'first-time': {
    id: 'first-time',
    title: 'First-time UX',
    subtitle: 'Empty state — Getting Started card, no projects yet',
  },
}

export const FRAME_IDS: FrameId[] = ['main', 'first-time']

export function isFrameId(value: string | undefined): value is FrameId {
  return value === 'main' || value === 'first-time'
}
